import React from 'react';
import { useDispatch } from 'react-redux';
import {
  CardContainer,
  CardContent,
  CardsWrapper,
  ContentColumn,
  CTAContainer,
  Description,
  Heading,
  Image,
  ImageColumn,
  ImageContainer,
  SubHeading
} from './styles';
import { CARD_PERCENTAGE_ICON } from '@Images';
import { CommonButton } from '@Components';
import { activateLoader } from '@Redux/actions/ui-trigger';
import { AppDispatch } from '../../store.type';
import { saveMinSourceAmountForCoupon, saveNewCouponCode } from '@Redux/actions/transaction';
import { Coupon, couponCMSDataType } from './utils';

interface ReferralCouponCardsProps {
  couponCMSData: couponCMSDataType;
  couponList: Coupon[];
  onApplyCouponTxnSummaryPage?: (couponCode: string) => void;
}

interface CardProps extends Coupon {
  couponCMSData: couponCMSDataType;
  applyCoupon: (couponCode: string, minSourceAmount: number) => void;
}

const Card: React.FC<CardProps> = ({
  code,
  label,
  value,
  terms,
  source_currency,
  disabled,
  destination_currency,
  min_source_amount,
  couponCMSData,
  applyCoupon
}) => {
  return (
    <CardContainer $disabled={disabled}>
      <CardContent>
        <ContentColumn>
          <Heading>{label}</Heading>
          <SubHeading>{`${couponCMSData?.transferAboveText} ${min_source_amount} ${source_currency}`}</SubHeading>
          <Description>{`${couponCMSData?.termsText} ${terms}`}</Description>
        </ContentColumn>

        <ImageColumn>
          <ImageContainer>
            <Image src={CARD_PERCENTAGE_ICON} alt="Card icon" />
          </ImageContainer>
        </ImageColumn>
      </CardContent>

      <CTAContainer>
        <CommonButton
          text={couponCMSData?.applyCta}
          type="link"
          disabled={disabled}
          onClick={() => applyCoupon(code, min_source_amount)}
        />
      </CTAContainer>
    </CardContainer>
  );
};

export const ReferralCouponCards: React.FC<ReferralCouponCardsProps> = (props) => {
  const { couponCMSData, couponList, onApplyCouponTxnSummaryPage } = props;
  const dispatch = useDispatch<AppDispatch>();

  const applyCoupon = (couponCode: string, minSourceAmount: number) => {
    dispatch(activateLoader());
    dispatch(saveNewCouponCode(couponCode));
    dispatch(saveMinSourceAmountForCoupon(minSourceAmount));
    onApplyCouponTxnSummaryPage && onApplyCouponTxnSummaryPage(couponCode);
  };

  return (
    <CardsWrapper>
      {couponList?.map((coupon, index) => (
        <Card key={index} {...coupon} couponCMSData={couponCMSData} applyCoupon={applyCoupon} />
      ))}
    </CardsWrapper>
  );
};
